import UserListPageContainer from './containers/UserListPageContainer'

export default UserListPageContainer
